import { GET_USEFUL_LINKS } from "../../../../enums/HrServices/UsefulLinks/usefulLinks";

export const usefulLinksAction = (data) => {
    return {
        type: GET_USEFUL_LINKS,
        payload: data,
    };
};
